import { useEffect, useState } from "react";
import { optimizeDisplayUsingAI } from "../../../../API/AliceGPT/AliceGPT";
import { postMessageToRuntime } from "../../../Helpers/Runtime/runtime";
import ShuffleMessage from "../../../Shared/ShuffleMessage/ShuffleMessage";
import { messagesWhenCreatingProject } from "../../../Shared/ShuffleMessage/MessagesHelper";
import usePublishApplication from "../../../../Hooks/Publish/usePublishApplication";
import useUser from "../../../../Hooks/User/useUser";
import { getCompressedJson } from "../../../../API/Export/ExportApi";
import { publishApplication, updateProjectPortalConfig } from "../../../Helpers/Launch";
import { useMsal } from "@azure/msal-react";

const STATUS = {
    CREATING_PAGES: "Creating pages using AI",
    PUBLISHING_PROJECT: "Publishing project"
}

function UpdateDisplayPages({ projectId, organizationId, instance, url }) {

    const msalContext = useMsal();

    const [status, setStatus] = useState("");
    const [showLoader, setShowLoader] = useState(false);

    function handleRedirect() {
        postMessageToRuntime({
            type: "projectCreated",
            openAppUrl: url
        })
    }

    async function handleRegenerate() {
        try {
            debugger;
            setShowLoader(true);
            setStatus(STATUS.CREATING_PAGES);
            await optimizeDisplayUsingAI(projectId);
            setStatus(STATUS.PUBLISHING_PROJECT);
            const compressedJson = await getCompressedJson(
                projectId, organizationId, msalContext.accounts[0]?.localAccountId, instance._id, false, false
            );
            updateProjectPortalConfig(projectId);
            const result = await publishApplication(
                msalContext, instance, compressedJson, false
            );
            if (result.status === "Success") {
                handleRedirect();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowLoader(false);
            // handleRedirect();
        }
    }

    if (showLoader) {
        return (
            <div className="d-flex flex-column justify-content-enter align-items-center w-100 h-100">
                <h3>{status}</h3>
                <div style={{ height: "80%" }}>
                    <img
                        alt="loader-clone"
                        height={"100%"}
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/library.gif`} />
                </div>
                <ShuffleMessage
                    data={messagesWhenCreatingProject}
                    interval={3000} />
            </div>
        )
    }

    return (
        <div className="d-flex flex-column justify-content-center align-items-center">
            <h3>Do you want to re-generate display configuration using AI?</h3>
            <div className="mt-2">
                <button onClick={handleRegenerate} className="btn btn-primary mx-2">Yes, regenerate!</button>
                <button onClick={handleRedirect} className="btn btn-secondary">No, take me to the app</button>
            </div>
        </div>
    )
}

export default UpdateDisplayPages;